import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import Skeleton from 'react-loading-skeleton'
import moment from 'moment'
import DocumentListContainer from "../../../../../Material/DocumentModal/DocumentListContainer"
import './RentalDocumentsTab.css'

const AllRentalsForDriverDocumentsQuery = gql`query AllRentalsForDriverDocumentsQuery($driverId: ID) {
    allRentals(driverId: $driverId, orderBy: ["-start_date"]) {
        edges {
            node {
                id
                pk
                stage
                startDate
                endDate
                car {
                    id
                    pk
                    vin
                    year
                    carModel {
                        id
                        pk
                        name
                        make
                    }
                }
            }
        }
    }
}`

const getSortedRentals = (data) => {
    const rentals = data && data.allRentals && data.allRentals.edges ? data.allRentals.edges.map(item => item.node) : []
    // Active agreement always shown (and defaulted to) first; otherwise keep the server's -start_date order.
    return [...rentals].sort((a, b) => (a.stage === "A_10" ? 0 : 1) - (b.stage === "A_10" ? 0 : 1))
}

class RentalDocumentsTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedAgreementPk: null,
        }
    }

    handleRentalsLoaded = (data) => {
        if (this.state.selectedAgreementPk !== null) return
        const sortedRentals = getSortedRentals(data)
        if (sortedRentals.length === 0) return
        this.setState({ selectedAgreementPk: sortedRentals[0].pk })
    }

    render() {
        return (
            <Query
                query={AllRentalsForDriverDocumentsQuery}
                variables={{ driverId: this.props.driverId }}
                fetchPolicy='cache-and-network'
                onCompleted={this.handleRentalsLoaded}
            >
                {({ loading, data }) => {
                    const rentals = getSortedRentals(data)
                    const selectedAgreement = rentals.find(rental => rental.pk === this.state.selectedAgreementPk)
                    return (
                        <div className="rental-documents-module">
                            <div className="rental-agreement-list">
                                {loading && rentals.length === 0 &&
                                    Array.from({ length: 3 }).map((_, index) => (
                                        <div className="mb-2" key={index}><Skeleton height={54} /></div>
                                    ))
                                }
                                {!loading && rentals.length === 0 &&
                                    <p className="rental-agreement-empty-text">No Rentals Found!</p>
                                }
                                {rentals.map(rental => {
                                    const carLabel = rental.car && rental.car.carModel
                                        ? `${rental.car.year || ""} ${rental.car.carModel.make || ""} ${rental.car.carModel.name || ""}`.trim()
                                        : "Unknown Car"
                                    const isActive = this.state.selectedAgreementPk === rental.pk
                                    return (
                                        <div
                                            key={rental.pk}
                                            className={"rental-agreement-item" + (isActive ? " active" : "")}
                                            onClick={() => this.setState({ selectedAgreementPk: rental.pk })}
                                        >
                                            <div className="rental-agreement-item__icon">
                                                <i
                                                    className={rental.stage === "_1" ? "fa fa-2x fa-ban" : "fa fa-2x fa-car"}
                                                    style={{ fontSize: "2em", color: rental.stage === "_1" ? "red" : rental.stage === "A_10" ? "green" : "orange" }}
                                                    aria-hidden="true"
                                                ></i>&nbsp;
                                            </div>
                                            <div className="rental-agreement-item__text">
                                                <p>{carLabel}</p>
                                                <small>
                                                    {rental.startDate ? moment(rental.startDate).format("ll") : "--"}
                                                    {" - "}
                                                    {rental.endDate ? moment(rental.endDate).format("ll") : "--"}
                                                </small>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="rental-documents-panel">
                                {!this.state.selectedAgreementPk ?
                                    <div className="rental-documents-empty">
                                        <i className="fa fa-file-text-o rental-documents-empty__icon" aria-hidden="true" />
                                        <div className="rental-documents-empty__title">Select a Rental</div>
                                        <p className="mb-0">Choose a rental on the left to view its documents.</p>
                                    </div>
                                    :
                                    <DocumentListContainer
                                        colSize={"4"}
                                        id={this.props.driverId}
                                        objectType={"driver"}
                                        hideFilters
                                        includeArchived
                                        currentUser={this.props.currentUser}
                                        agreementId={selectedAgreement && selectedAgreement.id}
                                        filters={[{ fieldName: "agreement", filterType: "equal", filterValues: this.state.selectedAgreementPk }]}
                                    />
                                }
                            </div>
                        </div>
                    )
                }}
            </Query>
        )
    }
}

export default RentalDocumentsTab
